import { DataFetcher } from "components/DataFetcher";
import Pod from "components/Pod/Pod";
import { useEffect, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { getFetchOptions } from "utils/fetch";
import QuickSearch from "../QuickSearch";
import SearchResultsList from "./components/SearchResultsList";
import AiChatTranscriptPanel from "../../AiOverview/UI/AiChatTranscriptPanel";
import AiSummarySlot from "../../AiOverview/UI/AiSummarySlot";

const SearchResults = () => {
	const { state: searchTerm } = useLocation();
	const [fetchData, setFetchData] = useState({});
	const [searchResults, setSearchResults] = useState([]);
	const [hasAiSearch, setHasAiSearch] = useState(false);
	// AI lifecycle
	const [aiState, setAiState] = useState("idle");
	// idle | loading | streaming | done | none
	const [aiSlotState, setAiSlotState] = useState("idle");

	const [searchParams] = useSearchParams();

	useEffect(() => {
		if (aiState !== "none") {
			setAiSlotState(aiState);
			return;
		}

		// Delay collapse to avoid flash
		const t = window.setTimeout(() => {
			setAiSlotState("none");
		}, 500);

		return () => window.clearTimeout(t);
	}, [aiState]);

	useEffect(() => {
		const value = sessionStorage.getItem("hasTeamsOffer");
		setHasAiSearch(value === "true");
	}, []);

	useEffect(() => {
		const options = getFetchOptions({
			method: "POST",
			body: searchTerm
		});
		setFetchData({ url: "api/Search/", options: options });
		if (hasAiSearch) {
			setAiState("loading");
		}
	}, [searchTerm, hasAiSearch]);

	return (
		<div className="grid-two-col gutters">
			<DataFetcher fetchData={fetchData} setData={setSearchResults}>
				<Pod title="Search Results">
					<div className="searchResultsList-searchterm">
						<h2>Search Term: {searchTerm}</h2>
					</div>
					{(hasAiSearch) && (
						<AiSummarySlot state={aiSlotState}>
							<AiChatTranscriptPanel
								enabled={hasAiSearch}
								initialQuestion={searchTerm}
								onStateChange={setAiState}
							/>
							
						</AiSummarySlot>
					)}
					<SearchResultsList searchTerm={searchTerm} searchResults={searchResults}></SearchResultsList>
				</Pod>
				<Pod title="Search" mobileOrder={2} sticky>
					<QuickSearch />
				</Pod>
			</DataFetcher>
		</div>
	);
};

export default SearchResults;